import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiEdit, FiTrash2, FiMoreVertical } from 'react-icons/fi';

const product = ({ currency, data, index, remove, rate, redirect, payment, elRef, isAdmin }) => {
    const [toggle, setToggle] = useState('none');
    let price = 0;
    let profit = 0;

    if (data.paymentStatus !== 'canceled') {
        if (currency === 'UZS') {
            if (data.exchange) {
                price = data.totalValue;
                profit = data.profit;
            } else {
                price = parseInt(data.salePriceAfterExchange * rate);
                profit = parseInt(data.profitAfterExchange * rate);
            }
        } else {
            if (data.exchange) {
                price = data.salePriceAfterExchange;
                profit = data.profitAfterExchange;
            } else {
                price = parseInt(data.totalValue);
                profit = parseInt(data.profit);
            }
        }
    }



    let color = '';
    switch (data.paymentStatus) {
        case 'paid':
            color = "primary"
            break;
        case 'canceled':
            color = "danger"
            break;
        case 'bonus':
            color = "success"
            break;
        default:
            color = 'warning'
            break;
    }

    return (
        <tr
            className="sale-item text-center"
            style={{ lineHeight: '35px' }}
            onClick={() => redirect(data.id)}
            ref={elRef}
        >
            <th scope="row">{index + 1}</th>
            {/* <td style={{ backgroundImage: data.img && data.img !== '' ? data.img : carpet }}>
                <div className="thumbnail-wrapper">
                    <img src={data.img && data.img !== '' ? data.img : carpet} onError={(e) => e.target.src = carpet} alt={data.name} className="img-thumbnail" width="60px" />
                </div>
            </td> */}
            <td><Link to={`/sales/${data.id}`}>{data.name}</Link></td>
            <td>{data.code}</td>
            <td>{data.dimensions}</td>
            <td>{data.roll > 0 ? (data.piecesForSale || '0') + ' m' : data.piecesForSale}</td>
            {/* <td>{data.totalSize}</td> */}
            <td>{parseInt(price).toLocaleString()}<sup>{currency}</sup></td>
            <td className="text-success">{parseInt(profit).toLocaleString()}<sup>{currency}</sup></td>
            <td>{data.brand}</td>
            <td>{new Date(data.updatedAt).toLocaleDateString()}</td>
            <td><span className={`badge badge-pill badge-sm status badge-${color} px-4 py-2`}>{payment[data.paymentStatus]}</span></td>
            <td className="d-flex td-status" onClick={(e) => {
                e.stopPropagation();
                setToggle(toggle === 'none' ? 'block' : 'none')
            }}>
                <FiMoreVertical />
                <span id="actions-link" style={{ display: toggle }}>
                    <Link
                        to={`/sales/${data.id}/edit`}
                        className="badge badge-sm badge-info"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <FiEdit />
                    </Link>
                    {
                        isAdmin && <button
                            className="badge badge-sm badge-danger"
                            onClick={(e) => {
                                e.stopPropagation()
                                remove(data.id, data.productId, data.piecesForSale)
                            }
                            }
                        >
                            <FiTrash2 />
                        </button>
                    }

                </span>
            </td>
        </tr>
    )
}


export default product;